import { render, staticRenderFns } from "./TW.vue?vue&type=template&id=77ecbdc5&scoped=true&"
import script from "./TW.vue?vue&type=script&lang=js&"
export * from "./TW.vue?vue&type=script&lang=js&"
import style0 from "./TW.vue?vue&type=style&index=0&id=77ecbdc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ecbdc5",
  null
  
)

export default component.exports